<template>
  <bk-page class="enterSharedinfoPage" pageType="navPage" :navBarInfo="navBarInfo">
    <template v-if="curShop">
      <bk-view class="view-header-main">{{ enterSharedinfoTitle }}</bk-view>
      <bk-view class="view-container">
        <bk-view class="view-formInfo-main">
          <bk-view class="view-form-main">
            <bk-view class="view-form-item view-required">
              <bk-input showFocusStatus langCode_placeholder="shareInvitefriend_enterSharedinfo_firstname" v-model:value="formData.refereeFirstName" />
            </bk-view>
            <bk-view class="view-form-item view-required">
              <bk-input showFocusStatus langCode_placeholder="shareInvitefriend_enterSharedinfo_lastname" v-model:value="formData.refereeLastName" />
            </bk-view>
            <bk-view class="view-form-item" :class="[systemInfo['MASE230'] ? 'view-required' :'']">
              <phone-input
								showFocusStatus
                :curShop="curShop"
                :dataList="dictInfo.intMobileCd"
                v-model="formData.refereeMobile"
                v-model:intMobileCd="formData.refereeMobileCdValue"
                v-model:intMobileCode="formData.refereeMobileCdCode"
                langCode_placeholder="res_add_mobile_phone_placeholder"
								@inputChange="verifyPhone"
								@change="verifyPhone"
              />
							<bk-view class="item-error-tip">{{mobileErrorText}}</bk-view>
            </bk-view>
            <bk-view class="view-form-item" :class="[!systemInfo['MASE230'] ? 'view-required' :'']">
              <bk-input showFocusStatus langCode_placeholder="shareInvitefriend_enterSharedinfo_email" v-model:value="formData.refereEemail" @change="verifyEmail" />
							<bk-view class="item-error-tip">{{emailErrorText}}</bk-view>
						</bk-view>
            <bk-view class="view-form-item">
              <bk-field-select type="choose" :dataList="genderList" langCode_placeholder="shareInvitefriend_enterSharedinfo_gender" v-model="formData.refereeGender" />
            </bk-view>
            
          </bk-view>
          <bk-lang class="view-confidential" code="shareInvitefriend_enterSharedinfo_confidential"></bk-lang>
        </bk-view>
        <bk-button langCode="shareInvitefriend_enterSharedinfo_submit" :loading="loadView==='save'" @click="handleSave"></bk-button>
      </bk-view>
    </template>

		<transition name="rightFadeIn">
      <bkEmailVerify 
				v-if="showPage==='bkEmailVerify'"  
				:email="formData.refereEemail" 
				@close="setShowPage()" 
				@confirm="handleSubmit"
			/>
    </transition>

  </bk-page>
</template>

<script>
	import phoneInput from '@/pages/login/signup/phoneInput/phoneInput.vue';
	import bkEmailVerify from '@/components/bk-business/bk-emailVerify/bk-emailVerify.vue';
	import { customerReq, shopReq, baseReq} from '@/reqService';

	export default {
		name:'enterSharedinfo',
		components:{ phoneInput, bkEmailVerify },
		data (){
			const { genderList } = this.$bk_Global.baseConstantInfo;
	
			return {
				genderList,
				loadView:'',
				navBarInfo: {
					// backFlag: true,
				},
				formData:{},
				curShop:null,
				dictInfo:{},
				languageType: this.$bk_getLanguageType(),
				isOpen:false,
				showPage:'',
				systemInfo:{},
				mobileErrorText:'',
				emailErrorText:'',
			};
		},
		computed:{
			enterSharedinfoTitle (){
				let title = this.$bk_lang['shareInvitefriend_enterSharedinfo_title'] || '';
				return title?.replace(/#VAR#/, this.curShop?.compName);
			}
		},
		created (){

			this.verifyPhone = this.$bk_debounce(this.verifyPhone)
			this.verifyEmail = this.$bk_debounce(this.verifyEmail)

			let token = this.$bk_getAccessToken();

			if (this.$bk_isNull(token)) {
				let that = this;
				window.viewCallback = function () {
					that.initData();
				};
				return;
			}
			this.initData();
		},
		methods:{
			async initData (){
				const {compId } = this.$route.query;

				if(compId){
					this.requestGetShopDetailByCompId(compId);
				}
			},
			async requestGetShopDetailByCompId (compId){
				const res = await shopReq.requestGetShopDetailByCompId(this, compId);

				this.curShop = res;
								
				const resDict = await baseReq.requestPostDictByTypeCode(this, ['intMobileCd']);

				this.formData.refereeMobileCdCode = res.countryCode?.toUpperCase() || 'CN';
				this.formData.refereeMobileCdValue = resDict.intMobileCd.find((v) => {
					return v.code === this.formData.refereeMobileCdCode; 
				})?.value;
				
				this.dictInfo = resDict;

				this.requestGetSystemParamsByCodes();
			},
			// 批量获取系统参数
			async requestGetSystemParamsByCodes () {
				const { compId, custId } = this.curShop;
				let params = {
					compId, custId,
					paramCodes:[
						'MASE230', // 客户身份验证标准
					],
				};
				const res = await baseReq.requestGetSystemParamsByCodes(this, params);
				this.systemInfo = res.systemInfo;
			},
			async requestGetPointRuleList (){
				const { custId, id } = this.curShop;
				const res = await baseReq.requestGetPointRuleList(this, {custId, compId: id }).catch(() => {
					this.loadView = '';
				});
				this.isOpen = res['PR011']?.status || res['PR01101']?.status;
			},
			setShowPage (showPage=''){
				this.loadView = '';
				this.showPage = showPage;
			},
			// 校验手机号是否已经存在
			verifyPhone (){
				const {refereeMobile, refereeMobileCdCode } = this.formData;

				if(!refereeMobile){
					this.mobileErrorText = '';
					return;
				}
				const { compId, custId } = this.curShop;
				customerReq.getEmailOrMobileIsExist(this, { 
					compId, custId, 
					mobile: refereeMobile, 
					mobileCdCode: refereeMobileCdCode
				}).then((res=[]) => {
					if(res.length>0){
						// 	const target = res.find((item) => {
						// 		return item.mobile === mobile && item.refereeMobileCdCode === refereeMobileCdCode;
						// 	});
						// 	if(target){
						this.mobileErrorText = this.$bk_lang['addCustomerProfile_mobileExist'];
						return;
						// }
					}
					this.mobileErrorText = '';
				}).catch(() => {
					this.mobileErrorText = '';
				});
			},
			// 校验邮箱是否已经存在
			verifyEmail (){
				const { compId, custId } = this.curShop;
				const {refereEemail} = this.formData;

				if(!refereEemail){
					this.emailErrorText = '';
					return;
				}

				customerReq.getEmailOrMobileIsExist(this, { compId, custId, email: refereEemail }).then((res=[]) => {
					if(res.length>0) {
						// const target = res.find((item) => {
						// 	return item.email === email;
						// });
						// if(target){
						this.emailErrorText = this.$bk_lang['addCustomerProfile_emailExist'];
						return;
						// }
					}
					this.emailErrorText = '';
				}).catch(() => {
					this.emailErrorText = '';
				});
			},
			// 验证
			validate (){
				const { refereeFirstName, refereeLastName, refereeMobile, refereEemail } = this.formData;
				const { MASE230 } = this.systemInfo;

				let inputPlaceholder = this.$bk_lang['bkForm_input_placeholder'];
				let message = '';

				if(this.$bk_isNull(refereeFirstName)){
					message = 'shareInvitefriend_enterSharedinfo_firstname';
				}else if(this.$bk_isNull(refereeLastName)){
					message = 'shareInvitefriend_enterSharedinfo_lastname';
				}else if((MASE230==2 || MASE230==1) && this.$bk_isNull(refereeMobile)){
					message = 'shareInvitefriend_enterSharedinfo_phonenumber';
				}else if((MASE230==2 || MASE230==0) && this.$bk_isNull(refereEemail)){
					message = 'shareInvitefriend_enterSharedinfo_email';
				}

				if(message){
					if(['ch', 'tw'].includes(this.languageType)){
						this.$bk_message.error(`${inputPlaceholder}${this.$bk_lang[message]}`);
					}else {
						this.$bk_message.error(`${inputPlaceholder} ${this.$bk_lang[message]}`);
					}
					return false;
				}

				if (this.mobileErrorText) {
					this.$bk_message.error(this.mobileErrorText);
					return false;
				}
				if (this.emailErrorText) {
					this.$bk_message.error(this.emailErrorText);
					return false;
				}

				return true;
			},
			getSubmitParams (){
				const {compId, memberId, userId } = this.$route.query;

				let params = {compId, userId, memberId, ...this.formData};
				return params;
			},
			async handleSave (){

				if(!this.validate()){
					return false;
				}
				
				this.loadView = 'save';

				await this.requestGetPointRuleList();

				if(!this.isOpen){
					this.loadView = '';
					this.$bk_message.error({langCode:'shareInvitefriend_enterSharedinfo_description'});
					return false;
				}

				const { refereEemail } = this.formData;
				const { compId } = this.$route.query;

				if(refereEemail){
					let res = await customerReq.requestGetMemberList(this, { 
						keyword:refereEemail || '', 
						compId
					});

					this.loadView = '';

					if(res?.list?.length){
						this.$bk_message.error(this.$bk_replaceVAR('shareInvitefriend_enterSharedinfo_msg_emailAlreadyexists', refereEemail));
						return false;
					}
				}

				this.setShowPage('bkEmailVerify');
			},
			handleSubmit (verifyCode){

				let params = this.getSubmitParams();

				params.verifyCodeDTO = { verifyCode, source:'MASE_APP_C' };

				this.loadView = 'save';

				customerReq.requestPostShareRefereeSubmit(this, params).then(() => {
					this.loadView = '';
					const { custId, id } = this.curShop;

					this.$bk_message.success({langCode:'shareInvitefriend_enterSharedinfo_msg_submittedSuccessfully'});
					
					window.location.href = `${location.origin}/shopDetail?custId=${custId}&compId=${id}`;
          
				}).catch(() => {
					this.loadView = '';
				});
			}
		}
	};
</script>

<style lang="less">
@import './enterSharedinfo.less';
</style>